import { getStorage, setStorage } from "@/utils/storage";
export const getNYDid = function (landid) {
  var reg = /(\d{18})(\d{3})/g;
  if (reg.test(landid)) {
    var frontNumber = RegExp.$1; // 前面18位数字
    return frontNumber + "000";
  } else {
    return landid + "";
  }
};

// Gcj-02 转 上海特殊偏移坐标系
export const transformGcj02ToShcrood = function (lat, lng, jsonp) {
  return new Promise((resolve) => {
    // 先 GCJ-02 转 wgs84
    var [newlat, newlng] = transformGCJ2WGS(lat, lng);
    resolve(transformWgs84ToShcrood(newlat, newlng, jsonp));
  });
};

// WGS84 转 上海特殊偏移坐标系
export const transformWgs84ToShcrood = function (lat, lng, jsonp) {
  return new Promise((resolve) => {
    var key = lat + "|" + lng;
    var wgs84ToShcroodMap = getStorage("wgs84ToShcroodMap") || {};
    if (wgs84ToShcroodMap[key]) {
      return resolve(JSON.parse(wgs84ToShcroodMap[key]));
    }
    jsonp("https://map1.shanghai-map.net/tdt_trans/trans.ashx", {
      x: lng,
      y: lat,
    }).then((res) => {
      if (res.msg === "success") {
        wgs84ToShcroodMap[key] = JSON.stringify([res.y, res.x]);
        setStorage("wgs84ToShcroodMap", wgs84ToShcroodMap);
        resolve([res.y, res.x]);
      } else {
        resolve([lat, lng]);
      }
    });
  });
};

// 转换GCJ-02坐标参考系统
export const transformGCJ2WGS = function (gcjLat, gcjLon) {
  // 火星坐标系GCJ02转地球坐标系WGS84
  var PI = 3.14159265358979324;
  const d = delta(gcjLat, gcjLon);
  return [gcjLat - d.lat, gcjLon - d.lon];
  function delta(lat, lon) {
    const a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
    const ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
    let dLat = transformLat(lon - 105.0, lat - 35.0);
    let dLon = transformLon(lon - 105.0, lat - 35.0);
    const radLat = (lat / 180.0) * PI;
    let magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    const sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * PI);
    dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * PI);
    return {
      lat: dLat,
      lon: dLon,
    };
  }
  function transformLat(x, y) {
    let ret =
      -100.0 +
      2.0 * x +
      3.0 * y +
      0.2 * y * y +
      0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(y * PI) + 40.0 * Math.sin((y / 3.0) * PI)) * 2.0) / 3.0;
    ret +=
      ((160.0 * Math.sin((y / 12.0) * PI) + 320 * Math.sin((y * PI) / 30.0)) *
        2.0) /
      3.0;
    return ret;
  }
  function transformLon(x, y) {
    let ret =
      300.0 +
      x +
      2.0 * y +
      0.1 * x * x +
      0.1 * x * y +
      0.1 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(x * PI) + 40.0 * Math.sin((x / 3.0) * PI)) * 2.0) / 3.0;
    ret +=
      ((150.0 * Math.sin((x / 12.0) * PI) + 300.0 * Math.sin((x / 30.0) * PI)) *
        2.0) /
      3.0;
    return ret;
  }
};
